import { getPerksSettings } from "../services/perksSettings";
export var UPDATE_SETTINGS = "UPDATE_SETTINGS";
var updateStore = function (settings) {
    return {
        type: UPDATE_SETTINGS,
        settings: settings
    };
};
var get = function () {
    return function (dispatch) {
        return getPerksSettings().then(function (settings) { return dispatch(updateStore(settings)); });
    };
};
export default { get: get };
